import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const companiesAtom = atom({ key: 'companiesAtom', default: [], effects_UNSTABLE: [persistAtom] });